import StateFactory from '@/store/helpers/StateFactory'

/**
 * The module's default state.
 *
 * @author Alejandro Sanchez <asanchez@claruscare.com>
 */
export default function state() {
	return StateFactory.paginatedEntity({
		filters: {
			ids: [],
			ends: null,
			providers: [],
			statuses: [],
			meta: {},
			search: '',
			starts: null,
			nonUrgent: null,
			types: [],
			urgent: null,
		},
		incomplete: {
			urgent: 0,
			nonUrgent: 0,
			total: 0,
		},
		loading: false,
		recentCalls: [],
		userActiveOnScreen: true,
		callCountDuringInactivity: 0,
	})
}
